import { EInputKind } from '../../../components/common/Input/Input';
import { ITableFilterMultiSelect } from '../../../modules/table';

export const filterMsisdnSearchInputType = (maxLength?: number): ITableFilterMultiSelect['searchInputTypeCallback'] => {
    if (!maxLength) return undefined;

    return searchValue => searchValue.length > maxLength ? EInputKind.error : EInputKind.normal;
};
